import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import "./ageGate.scss";

function CheckboxAgeGate({ page, title, instructions, updateAgeGate }) {
  const [cookieSwitch, setCookieswitch] = useState(true);
  const [isVerified, setIsVerified] = useState(true);

  const block = page.components.find(
    (component) => component.block_type === "AgeGateBlock"
  );
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 32,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor:
            theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,.35)"
          : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
      border: "1px solid #fff",
    },
  }));
  // Age verification
  const handleAgeGate = (isVerified) => {
    setIsVerified(isVerified);
    window.sessionStorage.setItem("ageGate_Value", isVerified.toString());

    if (isVerified) {
      // If user rejects tracking cookies, put 'r' for value
      const cookieValue = cookieSwitch ? block.cookie_value : "r";

      const expiresDate = new Date();
      expiresDate.setDate(expiresDate.getDate() + 30);
      const cookieString = `${
        block.cookie_name
      }=${cookieValue}; path=/; expires=${expiresDate.toUTCString()}`;

      document.cookie = cookieString;

      window.open(block.yes_button_link || "home", "_self");
      updateAgeGate(false);
    }
  };

  const handleCookieSwitch = (e) => {
    setCookieswitch(e.target.checked);
  };

  return (
    <>
      <div
        className="age-gate-container"
        style={{
          backgroundImage: "url(" + block.background_image + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundColor: block.background_color,
        }}
      >
        <div className="age-gate">
          <img src={block.brand_logo} alt={`${block.title} logo`}></img>
          <h2 style={{ color: block.text_color }}>
            {isVerified ? title || block.title : block.title_No}
          </h2>
          <label style={{ color: block.text_color }}>
            {isVerified
              ? instructions || block.instructions
              : block.instructions_No}
          </label>
          {isVerified && (
            <div className="button-container">
              <button
                className="btn"
                onClick={() => handleAgeGate(true)}
                style={{
                  backgroundColor: block.button_background_color,
                  borderColor: block.border_color,
                  color: block.button_text_color,
                }}
              >
                {block.submit_button_text}
              </button>
              <button
                className="btn"
                onClick={() => handleAgeGate(false)}
                style={{
                  backgroundColor: block.button_background_color,
                  borderColor: block.border_color,
                  color: block.button_text_color,
                }}
              >
                {block.cancel_button_text}
              </button>
            </div>
          )}
        </div>

        <div>
          <div>
            <Stack direction="row" spacing={1} alignItems="center">
              <AntSwitch
                checked={cookieSwitch}
                onChange={handleCookieSwitch}
                inputProps={{ "aria-label": "ant design" }}
              />
              <Typography
                style={{
                  color: block.text_color,
                  fontFamily: "Switzer",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "110%",
                }}
              >
                {cookieSwitch
                  ? "Allow All Cookies"
                  : "Strictly Necessary Cookies"}
              </Typography>
            </Stack>
          </div>
        </div>
        <div className="links" style={{ color: block.text_color }}>
          <p>
            <a
              href={block.terms_link}
              target="_blank"
              style={{ color: block.text_color }}
            >
              Terms and Conditions
            </a>
            <a
              href={block.privacy_link}
              target="_blank"
              style={{ color: block.text_color, marginLeft: "24px" }}
            >
              {" "}
              Privacy Policy{" "}
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
export default CheckboxAgeGate;
